<template>
  <div>
    <form class="">
      <!-- ID -->
      <div class="form-group row">
        <label for="id" class="col-sm-2 col-form-label text-dark">Id (*)</label>
        <div class="col-sm-4 ">
          <input
            id="id"
            class="form-control text-dark"
            v-bind:class="{ 'is-invalid': checkInvalidElements('id') }"
            type="number"
            v-model="book.id"
            @change="checkPrimaryId()"
            v-bind:disabled="inputDisabled"
          />
          <div
            class="invalid-feedback font-weight-bold"
            v-if="checkInvalidElements('id')"
          >
            {{ displayError("id") }}
          </div>
        </div>

        <label
          for="nr_volumi"
          class="col-sm-2 col-form-label text-dark text-sm-left text-md-right"
          >Nr. Volumi</label
        >
        <div class="col-sm-4">
          <input
            id="nr_volumi"
            class="form-control text-dark"
            type="text"
            v-model="book.nr_volumi"
            v-bind:disabled="inputDisabled"
          />
        </div>
      </div>

      <!-- AUTORE -->
      <div class="form-group row">
        <label for="autore" class="col-sm-2 col-form-label text-dark"
          >Autore</label
        >
        <div class="col-sm-10">
          <input
            id="autore"
            class="form-control  text-dark"
            type="text"
            v-model="book.autore"
            v-bind:disabled="inputDisabled"
          />
        </div>
      </div>

      <div class="form-group row">
        <label for="titolo" class="col-sm-2 col-form-label text-dark"
          >Titolo</label
        >
        <div class="col-sm-10">
          <input
            id="titolo"
            class="form-control text-dark"
            type="text"
            v-model="book.titolo"
            v-bind:disabled="inputDisabled"
          />
        </div>
      </div>

      <div class="form-group row">
        <label for="categoria" class="col-sm-2 col-form-label text-dark"
          >Categoria</label
        >
        <div class="col-sm-10">
          <input
            id="categoria"
            class="form-control text-dark"
            type="text"
            v-model="book.categoria"
            v-bind:disabled="inputDisabled"
          />
        </div>
      </div>

      <div class="form-group row">
        <label
          for="note_tipografiche"
          class="col-sm-2 col-form-label  text-dark"
          >Note Tipografiche</label
        >
        <div class="col-sm-10">
          <input
            id="note_tipografiche"
            class="form-control text-dark"
            type="text"
            v-model="book.note_tipografiche"
            v-bind:disabled="inputDisabled"
          />
        </div>
      </div>

      <div class="form-group row">
        <label
          for="data_pubblicazione"
          class="col-sm-2 col-form-label text-dark"
          >Data Pubblicazione</label
        >
        <div class="col-sm-10">
          <input
            id="data_pubblicazione"
            class="form-control text-dark"
            type="text"
            v-model="book.data_pubblicazione"
            v-bind:disabled="inputDisabled"
          />
        </div>
      </div>

      <!-- inizio zona admin -->
      <div v-if="isUserAdmin">
        <div class="form-group row">
          <label for="prezzo_acq" class="col-sm-2 col-form-label text-dark"
            >Prezzo Acquisto</label
          >
          <div class="col-sm-4">
            <input
              id="prezzo_acq"
              class="form-control text-dark"
              type="text"
              v-model="book.prezzo_acq"
              v-bind:disabled="inputDisabled"
            />
          </div>

          <label
            for="anno_acq"
            class="col-sm-2 col-form-label text-dark text-xs-left text-md-right"
            >Anno Acquisto</label
          >
          <div class="col-sm-4">
            <input
              id="anno_acq"
              class="form-control text-dark"
              type="text"
              v-model="book.anno_acq"
              v-bind:disabled="inputDisabled"
            />
          </div>
        </div>

        <div class="form-group row">
          <label for="note_acq" class="col-sm-2 col-form-label text-dark"
            >Note Segrete</label
          >
          <div class="col-sm-10">
            <textarea-autosize
              id="note_acq"
              class="form-control text-dark"
              type="text"
              v-model="book.note_acq"
              v-bind:disabled="inputDisabled"
            />
          </div>
        </div>
      </div>
      <!-- fine zona admin -->

      <div class="form-group row">
        <label for="provenienza" class="col-sm-2 col-form-label text-dark"
          >Provenienza</label
        >
        <div class="col-sm-10">
          <input
            id="provenienza"
            class="form-control text-dark"
            type="text"
            v-model="book.provenienza"
            v-bind:disabled="inputDisabled"
          />
        </div>
      </div>

      <div class="form-group row">
        <label
          for="descrizione_fisica"
          class="col-sm-2 col-form-label text-dark"
          >Descrizione Fisica</label
        >
        <div class="col-sm-10">
          <textarea-autosize
            class="form-control text-dark"
            id="descrizione_fisica"
            placeholder=""
            v-model="book.descrizione_fisica"
            v-bind:disabled="inputDisabled"
            rows="5"
          >
          </textarea-autosize>
        </div>
      </div>

      <div class="form-group row">
        <label for="descrizione" class="col-sm-2 col-form-label text-dark"
          >Descrizione</label
        >
        <div class="col-sm-10">
          <textarea-autosize
            class="form-control text-dark"
            id="descrizione"
            placeholder=""
            v-model="book.descrizione"
            v-bind:disabled="inputDisabled"
            rows="5"
          >
          </textarea-autosize>
        </div>
      </div>

      <div class="form-group row">
        <label for="note" class="col-sm-2 col-form-label text-dark">Note</label>
        <div class="col-sm-10">
          <textarea-autosize
            class="form-control text-dark"
            id="note"
            placeholder=""
            v-model="book.note"
            v-bind:disabled="inputDisabled"
            rows="3"
          >
          </textarea-autosize>
        </div>
      </div>

      <div class="form-group row">
        <label for="cataloghi" class="col-sm-2 col-form-label text-dark"
          >Cataloghi</label
        >
        <div class="col-sm-10">
          <input
            id="cataloghi"
            class="form-control text-dark"
            type="text"
            v-model="book.cataloghi"
            v-bind:disabled="inputDisabled"
          />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import appService from "@/service.js";

export default {
  name: "BookEdit",
  props: {
    book: {},
    inputDisabled: Boolean,
    originalId: String //accetta string perchè arriva da params.id
  },
  data: function() {
    return {
      errorElements: []
    };
  },
  computed: {
    isUserAdmin() {
      return this.$store.getters.isUserAdmin;
    }
  },
  methods: {
    checkPrimaryId() {
      //debugger //potrei inserire qui la logica di controller per id originale
      console.log("checkPrimaryId() from component");

      //cancella precedenti errori
      this.errorElements.splice(this.errorElements.find(x => x.id == "id"), 1);

      //se id non esiste
      if (!this.book.id) {
        this.errorElements.push({
          id: "id",
          error: `Id obbligatorio.`
        });
        return;
      }

      //id esiste, vediamo se è numerico
      var bookId = parseInt(this.book.id);

      //se id esiste
      if (!bookId) {
        this.errorElements.push({
          id: "id",
          error: `Inserisci Id numerico.`
        });
        return;
      }

      //se id è uguale a quello originale non è un errore
      if (bookId == this.originalId) {
        return;
      }

      appService.checkBookIdExists(this.book.id).then(res => {
        if (res.data == 1) {
          this.errorElements.push({
            id: "id",
            error: `Id ${this.book.id} non disponibile.`
          });
        }
      });
    },
    displayError(id) {
      console.log("displayError() from component");
      //debugger
      var x = this.errorElements.find(el => el.id == id).error;
      return x;
    },
    checkInvalidElements(id) {
      var x = this.errorElements.findIndex(el => el.id == id);

      //se ci sono errori, ritorna true
      //console.log("this.$emit('update:hasErrors', true)");
      this.$emit("update:hasErrors", x > -1);

      return x > -1;
    }
  }
};
</script>

<style scoped>
form input[type="text"]:disabled {
  background: transparent;
}
form input[type="number"]:disabled {
  background: transparent;
}
form textarea:disabled {
  background: transparent;
}
</style>
